import { PropsWithChildren } from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PaperProvider } from "react-native-paper";
import { ThemeProp } from "react-native-paper/lib/typescript/types";

import { buildTheme } from "./theme";
import { ModalContextProvider } from "../components/Modal/ModalContext";
import {
  ContextAwareFloatingSnackbar,
  SnackbarProvider,
} from "../contexts/SnackbarContext";

const queryClient = new QueryClient();
const defaultTheme = buildTheme();

type Props = PropsWithChildren<{ theme?: ThemeProp }>;
export default function PaperThemeProvider({ theme, children }: Props) {
  return (
    <QueryClientProvider client={queryClient}>
      <PaperProvider theme={theme || defaultTheme}>
        <SnackbarProvider>
          <ModalContextProvider>
            {children}
            <ContextAwareFloatingSnackbar />
          </ModalContextProvider>
        </SnackbarProvider>
      </PaperProvider>
    </QueryClientProvider>
  );
}
